// Constantes de jeu partagées par le serveur et le client. Unités : mètres, secondes, degrés pour les angles affichés.

export const TICK_RATE = 30;
export const TICK_DT = 1 / TICK_RATE;
export const MAX_PLAYERS = 12;

export const PLAYER_RADIUS = 0.35;
export const HIT_RADIUS = 0.5; // un peu plus large que le corps, pour les balles
export const EYE_HEIGHT = 1.5;
export const GUN_HEIGHT = 1.25;

export const SPEED = {
  walk: 3.4,
  sprint: 5.6,
  crouch: 1.7,
  aim: 2.4,
};

export const MAX_HP = 100;
export const RESPAWN_DELAY = 4;
export const SPRINT_TO_FIRE = 0.15; // délai entre la fin du sprint et le premier tir

// Rayon (m) dans lequel chaque action s'entend
export const NOISE = {
  crouch: 3,
  walk: 8,
  sprint: 18,
  reload: 6,
};

// Raid
export const RAID_TIME = 25 * 60; // s
export const JOIN_WINDOW = 180; // on ne rejoint plus un raid commencé depuis plus de 3 minutes
export const EXTRACT_TIME = 8; // s à rester dans la zone
export const SEARCH_STEP = 0.9; // s par objet révélé en fouillant
export const INTERACT_RANGE = 1.5;
export const BAG = { w: 6, h: 4 }; // ancien sac fixe (taille du sac de patrouille)
export const POCKETS = { w: 4, h: 2 }; // sans sac à dos : les poches
export const POUCH = { w: 2, h: 1 };
export const STASH = { w: 10, h: 24 };
export const CONT_GRID = { w: 6, h: 5 };
export const BODY_GRID = { w: 8, h: 6 };

// Infectés : 0 rôdeur, 1 coureur
// scream : rayon (m) dans lequel son cri attire les autres ; knock : son coup renverse et repousse
export const INFECTED: readonly { name: string; hp: number; wander: number; chase: number; damage: readonly [number, number]; sight: number; model: string; scream: number; knock?: boolean; scale: number }[] = [
  { name: 'Rôdeur', hp: 120, wander: 0.8, chase: 2.7, damage: [12, 18], sight: 18, model: 'Zombie_Basic', scream: 20, scale: 1 },
  { name: 'Coureur', hp: 70, wander: 1.0, chase: 4.7, damage: [8, 12], sight: 22, model: 'Zombie_Arm', scream: 20, scale: 0.97 },
  { name: 'Costaud', hp: 320, wander: 0.6, chase: 2.3, damage: [24, 34], sight: 16, model: 'Zombie_Basic', scream: 20, knock: true, scale: 1.28 },
  { name: 'Hurleur', hp: 60, wander: 0.9, chase: 3.4, damage: [5, 8], sight: 26, model: 'Zombie_Arm', scream: 48, scale: 0.92 },
  { name: 'Rampant', hp: 80, wander: 0.5, chase: 1.7, damage: [10, 14], sight: 10, model: 'Zombie_Basic', scream: 12, scale: 1 },
];
// Proportions à l'apparition (Rôdeur, Coureur, Costaud, Hurleur, Rampant)
export const INFECTED_MIX = [0.55, 0.22, 0.08, 0.07, 0.08];
export const INFECTED_WINDUP = 0.45; // s entre l'annonce du coup et l'impact
export const INFECTED_REACH = 1.05;

export const VIEW_RANGE = 70; // au-delà, un joueur n'est jamais envoyé au client
export const LAG_COMP_MAX = 0.15; // rembobinage maximal pour la compensation de latence
export const INTERP_DELAY = 0.1; // retard d'affichage des autres joueurs (interpolation)
